import { render, staticRenderFns } from "./LobbyTimer.vue?vue&type=template&id=5d2f932c&scoped=true&"
import script from "./LobbyTimer.vue?vue&type=script&lang=js&"
export * from "./LobbyTimer.vue?vue&type=script&lang=js&"
import style0 from "./LobbyTimer.vue?vue&type=style&index=0&id=5d2f932c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f932c",
  null
  
)

export default component.exports